import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { WorkBadgeReviewPolicySource } from "../../../../../WorkBadges/components/Policy/types";
import { WorkBadgeReviewPolicyStep } from "../../../../../WorkBadges/hooks/useWorkBadgeReviewPolicy";
import { getWorkBadgeReviewPolicyUrl } from "../../../../../WorkBadges/utils/getWorkBadgeReviewPolicyUrl";
import { SHIFT_DETAILS_BADGE_VERIFICATION_STEP_QUERY_PARAM } from "../../../../path";
import { type BadgeVerificationStep } from "../types";

interface UseNavigateToBadgePolicyParams {
  shiftId: string;
  qualificationName: string;
  currentStep: BadgeVerificationStep;
}

export function useNavigateToBadgePolicy(
  params: UseNavigateToBadgePolicyParams
): (policyStep: WorkBadgeReviewPolicyStep) => void {
  const { shiftId, qualificationName, currentStep } = params;
  const history = useHistory();

  return useCallback(
    (policyStep: WorkBadgeReviewPolicyStep) => {
      const policyUrl = getWorkBadgeReviewPolicyUrl({
        source: WorkBadgeReviewPolicySource.BADGE_VERIFICATION,
        shiftId,
        qualificationName,
        step: policyStep,
      });
      const searchParams = new URLSearchParams(history.location.search);
      searchParams.set(SHIFT_DETAILS_BADGE_VERIFICATION_STEP_QUERY_PARAM, currentStep);
      history.replace({
        pathname: history.location.pathname,
        search: searchParams.toString(),
        state: history.location.state,
      });
      history.push(policyUrl);
    },
    [history, shiftId, qualificationName, currentStep]
  );
}
